<template>
	<component :locked="locked" :is="comp" :part="part" @started="started = true"></component>
</template>

<script>

	import start from './Start'
	import pergunta from './Pergunta'

	export default {
		props: ['part', 'locked'],

		computed: {
			comp() {

				if(this.locked) {
					return 'pergunta'
				}

				if(this.part.EscutouAudio) {
					return 'pergunta';
				} else {
					if(this.started) {
						return 'pergunta'
					}
					return 'start';
				}
			}
		},

		data() {
			return {
				partId: null,
				started: false
			}
		},

		mounted() {
			this.partId = this.part.PartId
		},

		watch: {
			part() {
				if(this.partId !== this.part.PartId) {
					this.started = this.part.EscutouAudio
				}
			}
		},

		components: {
			'start': start,
			'pergunta': pergunta
		}

	}
</script>


// WEBPACK FOOTER //
// src/components/perguntas/audio/PerguntaAudio.vue